import cookie from 'js-cookie';

const getSessionId = () => {
    const bsid = cookie.get('bsid');

    if (!bsid) {
        return null;
    }

    const underscoreBsidIndex = bsid.indexOf('_');
    const isValidBsid = underscoreBsidIndex !== -1;

    return isValidBsid ? bsid.substr(0, underscoreBsidIndex) : null;
};

export default () => {
    const sessionId = getSessionId();
    const trackingId = cookie.get('firstTimeVisitor');

    return {
        sessionId,
        trackingId,
    };
};
